<script>
  import appConfig from "@/app.config";
  import axios from 'axios';
  
  export default {
    data() {
      return {}
    },
    components: {
      
    },
    metaInfo() {
      return {
        title: '404 에러 | 대구여성인권센터',
        meta: [
          {
            name: 'description',
            content: '페이지를 찾을 수 없습니다. 존재하지 않는 주소거나, 페이지가 변경 또는 삭제되었습니다.'
          },
          {
            property: 'og:title',
            content: '404 에러 | 대구여성인권센터'
          },
          {
            property: 'og:description',
            content: '페이지를 찾을 수 없습니다. 존재하지 않는 주소거나, 페이지가 변경 또는 삭제되었습니다.'
          },
          {
            property: 'og:url',
            content: window.location.href
          },
          {
            name: 'twitter:title',
            content: '404 에러 | 대구여성인권센터'
          },
          {
            name: 'twitter:description',
            content: '페이지를 찾을 수 없습니다. 존재하지 않는 주소거나, 페이지가 변경 또는 삭제되었습니다.'
          }
        ]
      }
    },
    mounted() {
      this.page_error();
    },
    methods: {
      page_error() {
        axios({
          method: 'POST',
          url: appConfig.fastapi + '/auth/page_error',
          data: {
            "user_agent": navigator.userAgent,
          },
        })
        .then((res) => {
          if (res.data.type == 'success') {
            this.$notify({ type: 'error', duration: 3000, title: '실패', text: '페이지를 찾을 수 없습니다.' })
          } else {
            this.$notify({ type: 'error', duration: 3000, title: '실패', text: '관리자에게 문의해주세요' })
          }
        })
        .catch((error) => { console.log(error); });
      },
    }
  };
</script>

<template>
  <section class="">
    <div class="row justify-content-center">
      <div class="col-lg-8 col-md-12 text-center">
        <div class="text-uppercase mt-4 display-4 text-primary text-bold">404 ERROR</div>
        <p class="text-muted para-desc mx-auto">존재하지 않는 주소거나, 페이지가 변경 또는 삭제되었나봐요</p>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 text-center">
        <router-link to="/" class="btn btn-primary mt-4 ml-2">첫화면으로 가기</router-link>
      </div>
    </div>
  </section>
</template>